import React from 'react'
import reviews from '../Assets/reviews.png';
import cus from '../Assets/cus.png';
import com from '../Assets/com.png';
import inc from '../Assets/inc.png';


function Testomonial() {
  return (
    <div className="py-20 flex justify-center">
      <div className="w-full flex flex-col items-center ">
        <div className='w-[80%] text-3xl sm:text-5xl pt-10 pb-20 extrabold text-center'>
            Why businesses like yours will love Elyzian
        </div>
        <div className="flex w-full gap-6 flex-wrap justify-center">
            <div className='border-[3px] hover:scale-105 hover:shadow-lg hover:cursor-pointer py-3 px-5 rounded-3xl w-[300px] h-[440px]'>
               <div className='p-5 flex justify-center'>
                <img className='w-24' src={reviews} alt="" />
               </div>
               <div className='text-2xl text-[#333333] bold text-center pb-8 border-b-[3px]'>Get more reviews</div>
               <div className='mt-7 flex flex-col  text-[18px] italic gap-2'>
              
               <span > “ We had 28 Google reviews…</span>
               <span className='bold not-italic text-[20px]'>And now we’re over 600.</span> 
               <span>And it’s easy for the staff. ”</span>
               </div>
            </div>
            <div className='border-[3px] hover:scale-105 hover:shadow-lg py-3 px-5 rounded-3xl w-[300px] h-[440px]'>
               <div className='p-5 flex justify-center'>
                <img className='w-24' src={cus} alt="" />
               </div>
               <div className='text-2xl text-[#333333] bold text-center pb-8 border-b-[3px]'>Convert customers</div>
               <div className='mt-7   text-[18px]  gap-2'>
              
               <span className="leading-7"> “ I'm getting </span>
               <span className='bold not-italic text-[20px] leading-7'>10x more website leads </span> 
               <span className="leading-7">using Elyzian's Webchat ”</span>
               </div>
            </div>
            <div className='border-[3px] hover:scale-105 hover:shadow-lg py-3 px-5 rounded-3xl w-[300px] h-[440px]'>
               <div className='p-5 flex justify-center'>
                <img className='w-24' src={com} alt="" />
               </div>
               <div className='text-2xl text-[#333333] bold text-center pb-8 border-b-[3px]'>Communicate faster</div>
               <div className='mt-7   text-[18px]  gap-2'>
              
               <span className='leading-7'> “ We respond to texts, social posts, and emails from customers </span>
               <span className='bold not-italic text-[20px]'>in 10 minutes </span> 
               </div>
            </div>
            <div className='border-[3px] hover:scale-105 hover:shadow-lg py-3 px-5 rounded-3xl w-[300px] h-[440px]'>
               <div className='p-5 flex justify-center'>
                <img className='w-24' src={inc} alt="" />
               </div>
               <div className='text-2xl text-[#333333] bold text-center pb-8 border-b-[3px]'>Increase revenue</div>
               <div className=' mt-7 text-[18px]  gap-2'>
              
               <span > “ In the last 12 months, we've generated </span>
               <span className='bold not-italic text-[20px]'>$130,000 in revenue</span> 
               <span> through the tool. ”</span>
               </div>
            </div>
        </div>
        <div className='mt-10 italic'>You could be the next  saying that.</div>
      </div>
    </div>
  )
}

export default Testomonial
